import gdprConsent from "form/modal/gdprConsent";
import userInfo from "core/userInfo";

import { USER_GDPR_CONSENT_FORM } from "../constants";

export const ModalGdprConsentForm = gdprConsent.createContainer(USER_GDPR_CONSENT_FORM, userInfo.getGdprText, userInfo.hasGdprConsent);
